<template>
	<div class="notice-bg" v-show='shouldNoticeShow'>
		<div class="notice">
			<div class="notice-title">{{title}}
			</div>
			<div v-for="item in content" class="notice-content">{{item}}
			</div>
			<div class="notice-confirm" @click="closeNotice">
			  我知道了
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'notify',
		props: ['title', 'content','shouldNoticeShow'],
		methods:{
			closeNotice:function(){
				this.$emit('closeNotice');
			}
		}
	}
</script>

<style>
.notice-bg{
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity .3s ease;
  z-index: 100;
}
.notice{
  width: 300px;
  border-radius: 4px;
  background-color: white;
  margin:80px auto 0;
}
.notice-title{
  padding-top:17px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #333333;
}
.notice-content{
  margin-top: 8px;
  font-size: 12px;
  padding: 0 38px;
  font-size: 16px;
  color:rgba(51,51,51,1);
}
.notice-confirm{
  width: 250px;
  font-size: 16px;
  background:rgba(82,84,255,1);
  color:rgba(255,255,255,1);
  line-height: 44px;
  height: 44px;
  text-align: center;
  display: inline-block;
  border-radius:22px;
  margin: 12px 25px 13px 25px;
}
</style>
